module.exports = __webpack_public_path__ + "img/75694.d842e9e9.svg";